/* eslint-disable @typescript-eslint/member-ordering */
import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, switchMap, tap } from 'rxjs/operators';
import { AuthService } from '../auth.service';
import { RouterFacade } from '../../router/router.facade';
import { CognitoUser } from 'amazon-cognito-identity-js';
import { of } from 'rxjs';
import * as AuthActions from './auth.actions';
import { Store } from '@ngrx/store';
import { cloneDeep } from 'lodash';
import { AuthActionType } from './auth.actions';
@Injectable()
export class AuthEffects {
  constructor(private store: Store<any>, private actions$: Actions, private authService: AuthService, private routerFacade: RouterFacade) {}

  doFirstLogin$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(AuthActions.DoFirstLogin),
        tap(() => {
          this.routerFacade.go(['/auth', 'force-change-password']);
          console.log('[Auth Effects] Navigate to Force Change Password');
        }),
      ),
    { dispatch: false },
  );

  doRefreshToken$ = createEffect(() =>
    this.actions$.pipe(
      ofType(AuthActions.DoRefreshToken),
      switchMap(() => this.authService.doRefreshToken()),
      map((user: CognitoUser) => {
        this.authService.setCognito(user);
        return {
          type: AuthActionType.SetAuthenticated,
        };
      }),
      catchError(error => of({
          type: AuthActionType.SetUnauthenticated,
        })),
    ),
  );
}
